module.exports = __webpack_public_path__ + "img/1727922232990-fe8e9871-462e-4d34-915a-e8e9091f918f.jpeg.c24d0904.webp";